import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { SAMPLES_COLUMNS } from './samplesColumnInfo'
import {
  BaseExportModal,
  BaseExportModalProps,
} from '../Modals/ExportModal/ExportModal'
import { useMemo } from 'react'

interface SampleRequestExportModalProps
  extends Omit<
    BaseExportModalProps,
    'columns' | 'title' | 'subTitle' | 'submitText'
  > {}

export default function SampleRequestExportModal(
  props: SampleRequestExportModalProps
) {
  const sampleColumnHelper = createExportColumnHelper({
    columns: SAMPLES_COLUMNS,
  })

  const columns = useMemo(() => {
    return [
      {
        title: 'Order Details',
        elements: [
          sampleColumnHelper.retrieveColumn('created'),
          sampleColumnHelper.retrieveColumn('date_needed'),
          sampleColumnHelper.retrieveColumn('modified'),
          sampleColumnHelper.retrieveColumn('status_display'),
          sampleColumnHelper.retrieveColumn('location_name'),
          sampleColumnHelper.retrieveColumn('location_address'),
          sampleColumnHelper.retrieveColumn('location_firstbite_id'),
          sampleColumnHelper.retrieveColumn('line_items_count'),
        ],
      },
      {
        title: 'Requestor Info',
        elements: [
          sampleColumnHelper.retrieveColumn('user_name'),
          sampleColumnHelper.retrieveColumn('user_email'),
          sampleColumnHelper.retrieveColumn('company_name'),
          sampleColumnHelper.retrieveColumn('company_firstbite_id'),
        ],
      },
    ]
  }, [sampleColumnHelper])

  return (
    <BaseExportModal
      {...props}
      title="Select Columns for Sample Requests Download"
      subTitle="Download up to 10,000 sample requests at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Download Sample Requests"
      columns={columns}
    />
  )
}
